import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const NotificationPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [editId, setEditId] = useState(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // Items per page
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

 const fetchNotifications = async () => {
    
  try {
    setLoading(true);
    const token = localStorage.getItem("token");

    const res = await fetch(
      `${baseUrl}/notification/list?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const result = await res.json();

    if (result.data) {
      setNotifications(result.data);
      setTotal(result.total || 0);
    }
  } catch (error) {
    toast.error("Failed to fetch notifications");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchNotifications();
  }, [page]);


 // Create or update notification 
 const handleCreateOrUpdate = async () => {
    if (!title || !message) {
      toast.error("All fields are required");
      return;
    }
  const token = localStorage.getItem("token");
  const url = editId
    ? `${baseUrl}/notification/edit/${editId}`
    : `${baseUrl}/notification/create`;
  const method = editId ? "PUT" : "POST";

  try {
    const res = await fetch(url, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ title, message }),
    });

    const result = await res.json();

    if (res.ok) {
      setTitle("");
      setMessage("");
      setEditId(null);
      toast.success(editId ? "Updated successfully!" : "Created successfully!"); // ✅ Toast shown only once
      await fetchNotifications(); // 🔁 Don't put toast in this function
    } else {
      toast.error(result.message || "Something went wrong");
    }
  } catch (error) {
    toast.error("Server error");
  }
};

// send notification
const handleSend = async (id) => {
  const token = localStorage.getItem("token");

  try {
    const res = await fetch(`${baseUrl}/notification/send-notification/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = await res.json();

    if (res.ok) {
      toast.success("Notification sent successfully!");
    } else {
      toast.error(result.message || "Failed to send notification.");
    }
  } catch (error) {
    toast.error("Error sending notification.");
  }
};


// delete notification
  const handleDelete = async (id) => {
  const token = localStorage.getItem("token");
  try {
    const res = await fetch(`${baseUrl}/notification/delete/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = await res.json();

    if (res.ok) {
      toast.success("Deleted successfully!"); // ✅ Show toast only here
      await fetchNotifications(); // Just refresh silently
    } else {
      toast.error(result.message || "Failed to delete.");
    }
  } catch {
    toast.error("Error deleting notification.");
  }
};

  const totalPages = Math.ceil(total / limit);

  return (
    <div className="flex bg-gray-900 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-6">
        <Toaster position="top-right" />
        <h2 className="text-2xl font-bold mb-4 text-white">Notifications</h2>

        {/* Create Notification */}
        <div className="bg-gray-800 p-4 rounded shadow mb-6">
            <input
            type="text"
            className="border border-gray-600 p-2 w-full mb-2 bg-gray-700 text-white"
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            />
            <textarea
            className="border border-gray-600 p-2 w-full mb-2 bg-gray-700 text-white"
            placeholder="Message"
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            />
            <button
            className="bg-yellow text-white px-4 py-2 rounded"
            onClick={handleCreateOrUpdate}
            >
            {editId ? "Update" : "Create"}
            </button>
        </div>


        {/* Notification List */}
        <div className="bg-dark-800 rounded shadow">
            {loading ? (
            <p className="p-4 text-gray-400">Loading...</p>
            ) : (
            <table className="min-w-full">
                <thead>
                <tr className="bg-yellow text-left">
                    <th className="p-3">Title</th>
                    <th className="p-3">Message</th>
                    <th className="p-3 text-center">Actions</th>
                </tr>
                </thead>
                <tbody>
                {notifications.length === 0 ? (
                    <tr>
                    <td colSpan={3} className="text-center p-4 text-gray-400">
                        No data found.
                    </td>
                    </tr>
                ) : (
                    notifications.map((noti) => (
                    <tr key={noti.id} className="border-b border-gray-900 hover:bg-gray-700 transition cursor-pointer text-gray-300">
                        <td className="p-3">{noti.title}</td>
                        <td className="p-3">{noti.message}</td>
                        <td className="p-3 text-center space-x-5">
                        <button
                            onClick={() => {
                            setEditId(noti.id);
                            setTitle(noti.title);
                            setMessage(noti.message);
                            }}
                            className="text-indigo-600 hover:underline"
                        >
                            Edit
                        </button>
                        <button
                                onClick={() => handleSend(noti.id)}
                                className="text-green-600 hover:underline"
                            >
                                Send
                            </button>
                        <button
                            onClick={() => handleDelete(noti.id)}
                            className="text-red-600 hover:underline"
                        >
                            Delete
                        </button>
                        </td>
                    </tr>
                    ))
                )}
                </tbody>
            </table>
            )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
            <div className="flex justify-center mt-6 space-x-2">
            <button
                disabled={page === 1}
                onClick={() => setPage((prev) => Math.max(1, prev - 1))}
                className="px-3 py-2 bg-white border rounded hover:bg-gray-100"
            >
                &laquo;
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
                <button
                key={pg}
                onClick={() => setPage(pg)}
                className={`px-4 py-2 border rounded ${
                    page === pg
                    ? "bg-blue-500 text-white"
                    : "bg-white hover:bg-gray-100"
                }`}
                >
                {pg}
                </button>
            ))}

            <button
                disabled={page === totalPages}
                onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
                className="px-3 py-2 bg-white border rounded hover:bg-gray-100"
            >
                &raquo;
            </button>
            </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default NotificationPage;
